import React, { FC, useContext } from 'react';
import { StatBlockGridProps, StatBlockGridData } from './index';
import { StatBlockGridStyled } from './styled';
import { Box, Text, Theme, useMediaQuery, belowBreakpoint } from '@bechtel/gds';
import { map } from 'lodash';
import { ThemeContext } from 'styled-components';
import { StatsSpinner } from '@bechtel/client-common';

export const StatBlockGrid: FC<StatBlockGridProps> = ({ data, label, subLabel, loading, ...rest }) => {
  const { breakpoints } = useContext<Theme>(ThemeContext);
  const isWideScreen = useMediaQuery(belowBreakpoint(breakpoints.widescreen));
  return (
    <StatBlockGridStyled data-testid="stat-block" pb={{ sm: isWideScreen ? '400' : '450' }} {...rest}>
      {map(data, (item: StatBlockGridData, index: number) => {
        return (
          <Box mb={{ sm: '100' }} justifyContent={{ sm: 'space-between' }} alignItems={{ sm: 'baseline' }} key={index}>
            <Box alignItems={{ sm: 'baseline' }} py={{ sm: '200' }} pr={{ sm: isWideScreen ? '450' : '550' }}>
              {!loading ? (
                <>
                  <Text
                    size={isWideScreen ? '500' : '600'}
                    family="graphik"
                    color="grey.1000"
                    weight="600"
                    data-testid={`stat-block-grid-value-${index}`}
                  >
                    {item.value}
                  </Text>
                  {item.total && (
                    <Text
                      color="grey.600"
                      size={isWideScreen ? '200' : '300'}
                      data-testid={`stat-block-grid-total-${index}`}
                    >
                      /{item.total}
                    </Text>
                  )}
                </>
              ) : (
                <StatsSpinner></StatsSpinner>
              )}
            </Box>
            {item.valueText && (
              <Text
                color="grey.600"
                size={isWideScreen ? '200' : '300'}
                data-testid={`stat-block-grid-valuetext-${index}`}
              >
                {item.valueText}
              </Text>
            )}
          </Box>
        );
      })}
      <Box justifyContent={{ sm: 'center' }} mt={{ sm: isWideScreen ? '000' : '400' }} pt={{ sm: '200' }}>
        {label && (
          <Text
            data-testid="stat-block-grid-label"
            size={isWideScreen ? '200' : '300'}
            color="grey.1000"
            weight="600"
            style={{ whiteSpace: 'nowrap' }}
          >
            {label}
          </Text>
        )}
        {subLabel && (
          <Text
            data-testid="stat-block-grid-sub-label"
            size={isWideScreen ? '200' : '300'}
            color="grey.600"
            style={{ whiteSpace: 'nowrap' }}
          >
            /{subLabel}
          </Text>
        )}
      </Box>
    </StatBlockGridStyled>
  );
};
